export default {
  id: "vrc-became-eku",
  pride: 39936,
  slug: "vrc-became-eku",
  category: ["video", "vrchat"],
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "【VRChat】现在我成了Eku，免费鸡蛋的毁灭者",
    en: "[VRChat] Now I Am Eku, Destroyer of Free Eggs"
  },
  bilibiliVideoId: "BV1FbLN6XEET",
  descriptionKey: {
    zh: "Eku 二创鬼畜，neta 奥本海默。无厘头搞笑风格。",
    en: "An Eku fan edit parody, referencing Oppenheimer. Pure nonsense comedy."
  },
  date: { year: 2026, month: 5, day: 19 },
  genres: ["二创", "鬼畜"],
  themes: ["搞笑", "无厘头", "VRChat"],
  developerNotesKey: {
    zh: "Eku二创鬼畜，neta奥本海默，真的很无厘头和搞笑。",
    en: "Eku fan edit parody referencing Oppenheimer. Genuinely absurd and hilarious."
  },
  tags: ["VRChat"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1FbLN6XEET/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
